import React from 'react';

// Types
import { GoalItem } from 'Shared/constants/types';

// Hooks
import { useGoal } from 'Shared/utils/hooks/use-goal';
import { useTranslation } from 'Shared/utils/hooks/use-translation';
import { useToggle } from 'Shared/utils/hooks';

// Components
import { WpButton, Size, Variant, Color } from 'Wpds/components/button';
import WpIcon from 'Wpds/components/icon/WpIcon';
import CompleteGoalModal from 'Shared/components/Goals/CompleteGoalModal/CompleteGoalModal';

type Props = {
  goal: GoalItem;
  size?: Size;
  variant?: Variant;
  color?: Color;
};

const GoalCompleteButton = ({ goal, size, variant, color }: Props) => {
  const { tr } = useTranslation();
  const { isComplete, canChangeStatus, isSaving, handleMarkComplete, handleMarkIncomplete } = useGoal({
    slug: goal.slug,
  });

  const [isOpen, toggleIsOpen] = useToggle(false);

  if (!canChangeStatus) return null;

  return (
    <>
      {isComplete ? (
        <WpButton size={size} variant={variant} color={color} onClick={handleMarkIncomplete} loading={isSaving}>
          <WpIcon name="check" />
          {tr('perform.goals.buttons.completed')}
        </WpButton>
      ) : (
        <WpButton size={size} variant={variant} color={color} onClick={toggleIsOpen} loading={isSaving}>
          <WpIcon name="check" />
          {tr('perform.goals.actions.mark_complete')}
        </WpButton>
      )}
      {isOpen && (
        <CompleteGoalModal
          goalSlug={goal.slug}
          goalResolutionNote={goal.resolutionNote}
          onSubmit={handleMarkComplete}
          onToggle={toggleIsOpen}
        />
      )}
    </>
  );
};

export default GoalCompleteButton;
